//알림메일 일괄 발송(/api/EmailAlimUpload) 결과 팝업
//보낸 수(SEND_COUNT), 네이버가 형식 오류로 거부해 뺀 주소(EXCLUDED), 이메일이 없거나 형식이 잘못돼 화면에서 뺀 참가자 수(noemail)
//SEND_COUNT 를 주지 않는 이전 백엔드면 기존 문구로 표시
const escape_html = (value) => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'}[c]));

const mailresult = {

    show(vm, data, noemail){
        const lines = [];
        if(data.resultCode == 0){
            lines.push(data.SEND_COUNT == null ? vm.$t('eul_msg12') : vm.$t('eul_mailres_ok', {count: data.SEND_COUNT}));
        }else{
            lines.push(data.SEND_ERROR ? vm.$t('eul_mailres_fail', {msg: data.SEND_ERROR}) : vm.$t('eul_msg13'));
        }
        if(noemail > 0){
            lines.push(vm.$t('eul_mailres_noemail', {count: noemail}));
        }

        let html = lines.map(escape_html).join('<br>');
        const excluded = Array.isArray(data.EXCLUDED) ? data.EXCLUDED : [];
        if(excluded.length > 0){
            html += '<br><br>' + escape_html(vm.$t('eul_mailres_excluded', {count: excluded.length})) +
                    "<div style='max-height:200px; overflow:auto; margin-top:8px; padding:8px; text-align:left; font-size:0.875rem; background:#f5f5f5; border-radius:4px;'>" +
                    excluded.map(escape_html).join('<br>') + '</div>';
        }
        return vm.$alert('', '', '', {html: html});
    },

}

export default mailresult
